import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ExpirationUpIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.7009 15.4882C15.3336 15.9862 14.9025 16.4235 14.4075 16.8C13.9126 17.1804 13.3693 17.4745 12.7777 17.6824C12.1861 17.8941 11.5655 18 10.916 18C10.1078 18 9.34803 17.8431 8.63657 17.5294C7.92118 17.2156 7.29094 16.7823 6.74582 16.2294C6.2006 15.6764 5.77328 15.0392 5.46395 14.3176C5.15462 13.5922 5 12.8196 5 12C5 11.1804 5.15462 10.4098 5.46395 9.68824C5.77328 8.96274 6.2006 8.32353 6.74582 7.77059C7.29094 7.21765 7.92118 6.78431 8.63657 6.47059C9.34803 6.15686 10.1078 6 10.916 6C11.7241 6 12.4858 6.15686 13.2011 6.47059C13.9126 6.78431 14.5409 7.21765 15.0861 7.77059C15.6313 8.31961 16.0586 8.95686 16.3679 9.68235C16.6773 10.4039 16.8319 11.1745 16.8319 11.9941M16.8319 11.9941L18 9.68235M16.8319 11.9941L14.7393 10.0759M10.916 8.57143V12L8.46667 14.5714"
            stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
const ExpirationUpIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ExpirationUpIconSvg}
    </SvgIcon>
);
export default ExpirationUpIcon
